import { useMemo } from 'react'
import type { EvidenceNumberFilter, EvidenceSummary } from '../../../types/evidence-numbers'

export interface RegisterScope {
  /** Whether the register is narrowed to the custody flow. */
  activeOnly: boolean
  /** Whether any search/status/type filter is applied. */
  hasFilters: boolean
  /** Count of evidence past bare registration. */
  inFlowCount: number
  /** Count of every evidence number in the register. */
  totalAll: number
}

/**
 * Derived register scope state (FR8).
 *
 * Kept out of the view so the render body stays declarative, and so the
 * defaults live in one place: a missing summary must read as zero rather than
 * silently rendering `undefined` into a count label.
 */
export function useRegisterScope(
  filter: EvidenceNumberFilter,
  summary: EvidenceSummary | null
): RegisterScope {
  const { activeOnly, search, status, numberType } = filter

  return useMemo(
    () => ({
      activeOnly: activeOnly ?? false,
      hasFilters: Boolean(search ?? status ?? numberType),
      inFlowCount: summary?.inFlowCount ?? 0,
      totalAll: summary?.totalAll ?? 0,
    }),
    [activeOnly, search, status, numberType, summary]
  )
}
